// coord-frontend/src/components/conversation/CoordAvatar.js
import React from "react";

// Coord's speaker mark: the "C" from public/favicon.svg (same path and
// transform) in a 24 px circle. Decorative — the visible name next to it in
// CoordMessageHeader carries the meaning, so it is hidden from assistive
// tech. primary-600 on background-card is 3.4:1 (non-text contrast ≥ 3:1).
const CoordAvatar = () => (
  <span
    aria-hidden="true"
    className="inline-flex h-6 w-6 shrink-0 rounded-full border border-border bg-background-card text-primary-600"
  >
    <svg viewBox="0 0 64 64" className="h-full w-full" focusable="false">
      <g transform="translate(14.09,49.53) scale(0.02353,-0.02353)">
        <path
          d="M786 -20Q588 -20 431.5 70.0Q275 160 184.5 331.0Q94 502 94 744Q94 987 185.0 1158.5Q276 1330 433.0 1420.0Q590 1510 786 1510Q913 1510 1022.5 1474.5Q1132 1439 1217.0 1371.0Q1302 1303 1356.0 1204.5Q1410 1106 1427 980H1118Q1108 1042 1079.5 1089.5Q1051 1137 1008.5 1170.5Q966 1204 911.0 1221.5Q856 1239 792 1239Q676 1239 588.5 1181.0Q501 1123 452.5 1012.5Q404 902 404 744Q404 583 453.0 473.0Q502 363 589.0 307.0Q676 251 791 251Q855 251 909.5 268.5Q964 286 1007.5 319.5Q1051 353 1079.5 401.0Q1108 449 1119 510H1428Q1416 406 1366.5 311.0Q1317 216 1235.0 141.0Q1153 66 1040.0 23.0Q927 -20 786 -20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  </span>
);

export default CoordAvatar;
